var render = function render(){var _vm=this,_c=_vm._self._c;return _c('symbol',{attrs:{"id":`${_vm.prefix}${_vm.slug}`,"viewBox":"0 0 16 16"}},[_c('circle',{attrs:{"cx":"8","cy":"8","r":"8","fill":_vm.getColor('sign'),"stroke":"none"}}),_c('polygon',{attrs:{"fill":_vm.getColor('icon'),"stroke":"none","points":"12,5.5 10.5,4 8,6.6 5.5,4 4,5.5 6.6,8 4,10.5 5.5,12 8,9.4 10.5,12 12,10.5 9.4,8 "}})])
}
var staticRenderFns = []

export { render, staticRenderFns }